import { AnthropicIcon, DeepSeekIcon, GoogleIcon, MetaIcon, OpenAIIcon } from "@storytell/bsky-icons";
import type { Features } from "@storytell/cp-client";
import type { Component } from "solid-js";
import { LogoNoText } from "~/components/brand";

export interface VendorInfo {
  name: string;
  icon: Component<{ size?: number; class?: string }>;
  color: string; // Tailwind color class
}

export const MODEL_VENDORS: Record<string, VendorInfo> = {
  storytell: {
    name: "Storytell",
    icon: LogoNoText,
    color: "",
  },
  anthropic: {
    name: "Anthropic",
    icon: AnthropicIcon,
    color: "text-orange-600 dark:text-orange-400",
  },
  openai: {
    name: "OpenAI",
    icon: OpenAIIcon,
    color: "text-green-600 dark:text-green-400",
  },
  google: {
    name: "Google",
    icon: GoogleIcon,
    color: "text-blue-600 dark:text-blue-400",
  },
  meta: {
    name: "Meta",
    icon: MetaIcon,
    color: "text-sky-600 dark:text-sky-400",
  },
  deepseek: {
    name: "DeepSeek",
    icon: DeepSeekIcon,
    color: "text-indigo-600 dark:text-indigo-400",
  },
};

export function getModelVendor(model: Features.Feature): VendorInfo {
  const modelValue = Number(model);

  if (modelValue >= 1000000 && modelValue <= 1099999) return MODEL_VENDORS.storytell;
  if (modelValue >= 1100000 && modelValue <= 1199999) return MODEL_VENDORS.anthropic;
  if (modelValue >= 1200000 && modelValue <= 1299999) return MODEL_VENDORS.openai;
  if (modelValue >= 1300000 && modelValue <= 1399999) return MODEL_VENDORS.google;
  if (modelValue >= 1400000 && modelValue <= 1499999) return MODEL_VENDORS.meta;
  if (modelValue >= 1500000 && modelValue <= 1599999) return MODEL_VENDORS.deepseek;

  return MODEL_VENDORS.storytell; // Default
}
